import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageSantander = props => {
  return <CityLandingPage cityKey="Santander" cityConfig={cityContent.santander} {...props} />;
};

export default LandingPageSantander;
